import LandingSlider from "areas/landing/elements/landing-slider"
import { Box } from "components/common"
import { jewlr_t } from "helpers/application"
import { SectionDescription, SectionTitle } from "jewlr/pages/components"

const OtherCollections = () => (
  <Box mb={6}>
    <Box
      mb={2}
      pl={{ _: 4, tablet: 2 }}
      pr={2}
      textAlign={{ tablet: "center" }}
    >
      <SectionTitle>Other Collections</SectionTitle>
      <SectionDescription display={{ _: "none", tablet: "block" }}>
        Create the perfect {jewlr_t("terms.personalized")} gift.
      </SectionDescription>
    </Box>
    <LandingSlider
      element={{
        slider_type: "native",
        item_width: {
          _: "70vw",
          tablet: 4,
        },
        style: {
          bg: "#FFFFFF",
          mx: { tablet: "-16px" },
          pb: 3,
          pr: {
            tablet: "16px",
          },
        },
        arrow_style: {
          top: "31%",
        },
        items: [
          {
            cta: {
              text: "Shop Now",
            },
            folder:
              "2020-new-landing-collections/for-him/rev-v2/tungsten-rings",
            link: "/mens-tungsten-rings",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Tungsten Rings",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev-v2/signet-rings",
            link: "/mens-signet-rings",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Signet Rings",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev-v2/celtic",
            link: "/mens-celtic-rings",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Celtic & Claddagh",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev-v2/dogtags",
            link: "/mens-dog-tags",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Dog Tags",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev-v2/religious",
            link: "/mens-cross-jewelry",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Religious",
            },
            type: "image",
          },
        ],
      }}
    />
  </Box>
)

export default OtherCollections
